import { PhoneNumberType } from './booking.models';

export interface VerifyRequest {
  verifyCode: string;
  verifyToken: string;
}

export interface ValidationContact {
  key: string;
  phoneNumber: string;
  phoneNumberType: PhoneNumberType;
  verificationType: BookingVerificationTypeEnum;
}

export enum BookingVerificationTypeEnum {
  PASSENGER,
  CONTACT,
}

export enum BookingVerificationStatusTypeEnum {
  UNVERIFIED,
  VERIFIED,
  NO_PHONE_NUMBERS,
}

export interface N0BookingVerificationRequest {
  phoneNumberType: PhoneNumberType | undefined;
  requesterKey: string;
  verificationType: BookingVerificationTypeEnum;
}

export interface N0VerificationResponse {
  mobilePhoneNumber: string;
  verify: boolean;
  verifyToken: string;
}

export interface N0BookingVerificationStatusResponse {
  status: BookingVerificationStatusTypeEnum;
}

export interface N0CompleteBookingVerificationResponse {
  recordLocator: string;
  verified: boolean;
}
